import React from "react";
import { LoginForm } from "../../components/LoginForm/LoginForm";

import "./LoginPage.scss";
import { Header } from "../../components/Header/Header";

const LoginPage = () => {
    return (
        <>
            <Header ></Header>
            <div className="LoginPage d-flex justify-content-center align-items-center">
                <LoginForm></LoginForm>
            </div>
        </>);
}

export { LoginPage };
